interface ILogger {
    readonly info: (message: string, ...details: readonly any[]) => void;
    readonly warn: (message: string, ...details: readonly any[]) => void;
    readonly error: (message: string, ...details: readonly any[]) => void;
    readonly debug: (message: string, ...details: readonly any[]) => void;
  }
  
  export const loggerFactory = (): ILogger => {
    const logMessage = (type: 'debug' | 'info' | 'warn' | 'error', message: string, details: readonly any[]) => {
      // eslint-disable-next-line no-console
      console[type](`Logger - message: ${message}`);
      if (details.length > 0) {
        for (const detail of details) {
          // eslint-disable-next-line no-console
          console[type](detail);
        }
      }
    };
  
    return {
      info: (message: string, ...details: readonly any[]) => logMessage('info', message, details),
      warn: (message: string, ...details: readonly any[]) => logMessage('warn', message, details),
      error: (message: string, ...details: readonly any[]) => logMessage('error', message, details),
      debug: (message: string, ...details: readonly any[]) => logMessage('debug', message, details),
    };
  };